import { render, staticRenderFns } from "./RemainingInventory.vue?vue&type=template&id=17a0d996&scoped=true&"
import script from "./RemainingInventory.vue?vue&type=script&lang=js&"
export * from "./RemainingInventory.vue?vue&type=script&lang=js&"
import style0 from "./RemainingInventory.vue?vue&type=style&index=0&id=17a0d996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a0d996",
  null
  
)

export default component.exports